package kpt.core.network

import kotlin.String

internal object BuildKonfig {
  public val FRED_API_KEY: String = "e092e4eff5b9d82b5ff2af620966d7a9"

  public val SUPABASE_PUBLISHABLE_KEY: String = "sb_publishable_krRqwMQ5NnoHRzTUmVRm-Q_oz5WpzZ_"
}
